module.exports = __webpack_public_path__ + "static/media/addFunds.41590b09.svg";